import React from 'react';
import { Card, CardContent } from './card';
import { cn } from '../../lib/utils';

interface ProgressCircleProps {
  title: string;
  value: number;
  percentage: number;
  icon?: React.ReactNode;
  span?: number;
  className?: string;
}

export function ProgressCircle({ 
  title, 
  value, 
  percentage,
  icon, 
  span = 1,
  className 
}: ProgressCircleProps) {
  const circumference = 2 * Math.PI * 45; // radius of 45
  const strokeDasharray = circumference;
  const strokeDashoffset = circumference - (percentage * circumference);

  return (
    <Card className={cn(
      "min-h-[140px]",
      span > 1 && `col-span-${span}`,
      className
    )}>
      <CardContent className="p-6 flex flex-col justify-between h-full">
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <p className="text-sm font-medium text-muted-foreground mb-2">
              {title}
            </p>
            <p className="text-2xl font-bold text-foreground mb-4">
              {value.toLocaleString('pt-BR')}
            </p>
            
            {/* Circular Progress */}
            <div className="relative w-16 h-16">
              <svg className="w-16 h-16 transform -rotate-90" viewBox="0 0 100 100">
                {/* Background circle */}
                <circle
                  cx="50"
                  cy="50"
                  r="45"
                  stroke="currentColor"
                  strokeWidth="8"
                  fill="transparent"
                  className="text-muted opacity-20"
                />
                {/* Progress circle */}
                <circle
                  cx="50"
                  cy="50"
                  r="45"
                  stroke="currentColor"
                  strokeWidth="8"
                  fill="transparent"
                  strokeDasharray={strokeDasharray}
                  strokeDashoffset={strokeDashoffset}
                  className="text-primary transition-all duration-300 ease-in-out"
                  strokeLinecap="round"
                />
              </svg>
              {/* Percentage text */}
              <div className="absolute inset-0 flex items-center justify-center">
                <span className="text-xs font-bold text-foreground">
                  {Math.round(percentage * 100)}%
                </span>
              </div>
            </div>
          </div>
          {icon && (
            <div className="ml-4 flex-shrink-0">
              {icon}
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}